module.exports = __webpack_public_path__ + "img/header.eb651bce.jpg";